var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-close",
      class: _vm.computedClass,
      style: _vm.componentStyle,
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "close-before", style: _vm.contentStyle }),
      _c("div", { staticClass: "close-after", style: _vm.contentStyle })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }